import { EventHookManager, IProperyChangedArgs } from "./EventHookManager";
import { INotifyPropertyChanged } from "./Interfaces";

export class PropertyChangedUtility {
    
    static onPropertyChanged(property: string, callback: (arg: IProperyChangedArgs) => void) {
        return this.onPropertiesChanged([property], callback);
    }


    static onPropertiesChanged(properties: string[], callback: (arg: IProperyChangedArgs) => void) {

        return (arg: IProperyChangedArgs) => {
            if (properties.find(p => p === arg.property))
                callback(arg);
        }
    }
}

export class NotifyPropertyChangedBase implements INotifyPropertyChanged {

    /**************************************************************************
     * 
     * Primary way clients will interact, used to (un)subscribe to the event
     * 
     *************************************************************************/
    public get PropertyChanged() { return this._PropertyChangedEventHook.eventHook; }
    private _PropertyChangedEventHook = new EventHookManager<IProperyChangedArgs>();

    public get isDirty() {
        return this._isDirty;
    }

    public ClearDirty() {
        this._isDirty = false;
    }
    private _isDirty = false;

    /**************************************************************************
     * 
     * Used by derived classes to update values and trigger the event
     * 
     *************************************************************************/
    protected UpdateAndFire(property: string, newValue: any, overrideDirty?: boolean) {
        //
        // Check to see if this is really setting a new value
        //
        const oldValue = (this as any)[property];
        if (oldValue !== newValue) {

            // Do the Update
            //
            (this as any)[property] = newValue;
            this._isDirty = overrideDirty ? this._isDirty : true;
            this._PropertyChangedEventHook.Fire({ source: this, property: property });
        }
    }

    /**************************************************************************
     * 
     * Straight trigger of the event for derived classes to use.
     * 
     *************************************************************************/
    protected FireChanged = (friendlyName: string, overrideDirty?: boolean) => {
        this._isDirty = overrideDirty ? this._isDirty : true;
        this._PropertyChangedEventHook.Fire({ source: this, property: friendlyName });
    }
}